module.exports = __webpack_public_path__ + "img/nursery-black.c2fae7d4.svg";